import getV2AxiosInstance from '../utils/v2Axios.js';
import axios from 'axios';


export function setTagsList(data){
    return {
        type: 'SET_TAGS_LIST',
        payload: data
    };
}
/**
 * returns response or error of api call
 * @param  {object} response [response of api call]
 * @return {object}          [response or error]
 */
function handleResponse(response) 
{
  if (response.status == 200)
  {
    return response;
  }
  else
  {
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}


/**
 * gets list of end business type list
 */
export function getTagsList(){
    return dispatch => {
      return getV2AxiosInstance().post("/bridge/en/invoxapi/Client", {
        action: "listEndBusinessByClient",
      }).then(handleResponse)
      .then(data => { return data.data.response.items; });
      //.then(data => dispatch(setTagsList(data.data.response.items)))
    };
}

/**
 * gets list of end business type list by serice_id
 * @param  {string} service_id
 */
export function getTagListByService(service_id){
    return dispatch => {
      return getV2AxiosInstance().post("/bridge/en/invoxapi/Service", {
        action: "listEndBusinessByServiceId",
        params: { service_id: service_id },
      }).then(handleResponse)
      .then(function (data) { 
          data.data.response.items = data.data.response.items.map(function(tag_data) {
             tag_data.id = parseInt(tag_data.id);
             return tag_data;
          });
          return data.data.response.items; 
      });
      // .then(data => { return data.data.response.items; });
      // .then(data => dispatch(setTagsList(data.data.response.items)))
    };
}


/**
 * sets business outcome
 * @param {object} payload
 */
export function setTags(payload){
    return (dispatch) => {
      return getV2AxiosInstance()
        .post("/bridge/en/invoxapi/Call", {
          action: "setTags",
          params: {
            call_id: payload.call_id,
            tags: payload.tags
          },
          
        })
        .then(handleResponse);
    };
}

export function getAssignedTags(callId){
    return (dispatch) => {
        return getV2AxiosInstance()
          .post("/bridge/en/invoxapi/Call", {
            action: "getTags",
            params: {
              call_id: callId,
            },
          })
          .then(handleResponse);
      };
  }




// WEBPACK FOOTER //
// ./src/actions/tags.js